export const INDICATOR_OPTIONS = [
  "id",
  "type",
  "name",
  "unit",
  "period",
  "removed",
];

export const INDICATOR_NAME_CHILDREN = ["nameRu", "nameEn"];
